import { Tag } from "@blueprintjs/core";
import * as React from "react";
import styled from "styled-components";

const TagContainer = styled.div`
  & * + * {
    margin-left: 5px;
  }
`;

export const GridTags = ({ tags }: { tags: string[] }) => {
  return (
    <TagContainer>
      {tags.map((f, i) => (
        <Tag key={i}>{f}</Tag>
      ))}
    </TagContainer>
  );
};
